import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";

import agreementPlanedDefectDataStore from "../../../store/agreementPlanedDefectData";
import { authStore } from "../../../store/authStore";
import DefectTable from "./table";

import { IDefectDataProps } from "..";

const AgreementPlanedDefectData: FC<IDefectDataProps> = observer(
  ({ columns, openDefectCard }) => {
    const { data, paginator, isLoading, sorter, allData, selectedRows } =
      agreementPlanedDefectDataStore;
    const { defectNotify } = authStore;

    const openDefect = (id: string) => {
      if (openDefectCard) {
        openDefectCard(id, columns?.planned);
      }
    };

    useEffect(() => {
      allData();
    }, [
      paginator.page,
      paginator.perPage,
      agreementPlanedDefectDataStore.filter.filterItems,
      sorter.changingKey,
    ]);

    const parseChildren = (col) => {
      return {
        ...col,
        children:
          col.children?.length > 0
            ? col.children
                .filter((col) => columns.visibleCols.keys.includes(col.key))
                .map(parseChildren)
            : null,
      };
    };

    const cols = columns.columns
      .filter((col) => columns.visibleCols.keys.includes(col.key))
      .map(parseChildren);

    const rowSelection = defectNotify
      ? {
          selectedRowKeys: selectedRows.keys,
          onChange: (selectedRowKeys) => {
            selectedRows.setKeys([...selectedRowKeys]);
          },
        }
      : null;

    return (
      <DefectTable
        columns={cols}
        dataSource={data}
        paginator={paginator}
        sorter={sorter}
        isLoading={isLoading.value}
        planned
        rowSelection={rowSelection}
        openDefect={openDefect}
      />
    );
  },
);

export default AgreementPlanedDefectData;
